





































































































import { Component, Mixins } from 'vue-property-decorator';

import { View } from 'client-website-ts-library/plugins';

import SideBySide from '../components/Layout/SideBySide.vue';
import Row from '../components/Layout/Row.vue';
import Column from '../components/Layout/Column.vue';
import Form from '../components/Forms/Form.vue';
import TestimonialCarousel from '../components/TestimonialCarousel.vue';

@Component({
  components: {
    SideBySide,
    Row,
    Column,
    Form,
    TestimonialCarousel,
  },
})
export default class Home extends Mixins(View) {
  goToSignUp(): void {
    try {
      const elmnt = document.getElementById('signup');
      if (elmnt) elmnt.scrollIntoView({ behavior: 'smooth' });
    } catch (err) {
      console.log('No signup element found');
    }
  }
}
